// extracted by mini-css-extract-plugin
module.exports = {"container":"CMS_container__2__j8"};